import React, { useMemo } from "react";

import { Typography, Select } from "clearsense-ui/components";

import { JOB_STATUS_TYPE } from "../../../constants";

const PredictJobList = ({ jobList, isLoading, handleJobSelect }) => {
  const options = useMemo(
    () =>
      jobList &&
      jobList?.map(job => ({
        label: job.name,
        value: job,
        disabled: job.status !== JOB_STATUS_TYPE.finished,
      })),
    [jobList]
  );

  return (
    <div className="flex items-center w-2/6 gap-3">
      <Typography style="h5" className="font-semibold text-shades-darkest">
        {isLoading
          ? "Loading predictions"
          : `${jobList?.length || 0} Predictions`}
      </Typography>

      {jobList && (
        <Select
          name="prediction-jobs"
          placeholder="Select Prediction"
          size="small"
          loading={isLoading}
          onChange={({ value }) => value && handleJobSelect(value)}
          options={options}
          className="min-w-[180px]"
        />
      )}
    </div>
  );
};

export default PredictJobList;
